import { ILog } from "./ILog";
import { LogLevel } from "./LogLevel";

export class ConsoleLogProvider implements ILog {
    log(type: string, level: LogLevel, ...messages: string[]): void {
        console.log(`[${level}] - [${type}] - ${messages.join(" ")}`);
    }
}
